import React, { createContext, useState, useEffect, useCallback } from "react";
import questionsData from "./NewquestionsData.json"; 
import EntraquestionData from "./EntraquestionData.json"
import GooglequestionData from "./GooglequestionData.json"
import M365 from "./M365questionsData.json";
import GenAI from "./gen_ai_questions.json";
import BlockChain from "./blockchain_security_questions.json";
import iso_27001_compliance_checklist from "./iso_27001_compliance_checklist.json";
import CISSecurityAssessment from "./CISSecurityAssessment.json";
import compliance_checklist from "./compliance_checklist.json";
import WirelessAndApplicationDatabaseSecurityQue from "./WirelessAndApplication&DatabaseSecurityQue.json";
import DevSecOps from "./DevSecOps.json";
import OperationalResilience from "./OperationalResilience.json";
import DORA from "./DORA.json";
import CRA from "./CRA.json";
import NIS2 from "./NIS2.json";
import CSCRF from "./CSCRF.json";
import NCSB from "./NCSB.json";
import CSRB from "./CSRB.json";
import CSRBIncidentReporting from "./CSRBIncidentReporting.json"
import GovAssureSecurity from "./GovAssureSecurity.json";
import CIRCIA from "./CIRCIA.json";
import AIExecutiveOrdersSecurity from "./AIExecutiveOrdersSecurity"
import PS21 from "./PS21_3.json";
// import IncidentReporting from "./IncidentResponse.json";
import ThirdPartyInfrastructure from "./MSPDataCentreFocus.json";
import RegulatoryEngagement from "./RegulatorEngagement.json";
import EncryptionICOReadiness from "./ICOEncryptionParticipation.json";
import QuantumResilientSecurity from "./PostQuantumCryptography.json";
import PECRCompliance from "./PECRAlignment.json";
import TelecomSecurityAct from "./TelecomSecurityAct.json";
import PCIDSSCompliance from "./PCIDSSCompliance.json";
import NCSCCAF from "./NCSCCAF.json";
import PSNCompliance from "./PSNCompliance.json";
import OTIoTSecurity from "./OTIoTSecurity.json";
//import IEC62443NIST80082 from "./IEC62443NIST80082.json";
import NetworkSecurity from "./NetworkSecurity.json";
import PrivateCloudHypervisor from "./PrivateCloudHypervisor.json";
import HIPAA from "./HIPAA.json";
import RED from "./RED.json";
import EUAIActCompliance from "./EUAIActCompliance.json";
import BS7858Security from "./BS7858Security.json";
import SOC2 from "./SOC2/SOC2.json";
import NISTSP80053 from "./NISTSP80053/NISTSP80053.json";
import NISTSP80063IAM from "./NISTSP80063IAM/NISTSP80063IAM.json";
import NISTPrivacyFramework from "./NIST Privacy Framework/NISTPrivacyFramework.json";
import NISTSP800161 from "./Supply Chain Risk/NISTSP800161.json";
import NCSCSupplyChainGuidelines from "./Supply Chain Risk/NCSCSupplyChainGuidelines.json";
import CERTINSupplyChainGuidelines from "./Supply Chain Risk/CERTINSupplyChainGuidelines.json";
import PDPL from "./PDPL.json"
import CyberEssential from "./Cyberessential.json"
import SOXCompliance from "./SOXCompliance.json"
import MITRE  from "./MITRE.json";
import OWASP from "./OWASP.json";
import COBIT from "./COBIT.json";
import Oraclequestiondata from "./Oraclequestiondata.json"



// Create the context
export const ScoreContext = createContext();

// Provide the context
export const ScoreProvider = ({ children,userData }) => {
  const loadResponsesFromLocalStorage = () => {
    const savedResponses = localStorage.getItem("responses");
    return savedResponses ? JSON.parse(savedResponses) : {};
  };
  const [overviewData, setOverviewData] = useState(null);
  const [scoreData, setScoreData] = useState({});
  const [responses, setResponses] = useState(loadResponsesFromLocalStorage);
  const [actionPlan, setActionPlan] = useState([]); // Store action plan as state
  const [loading, setLoading] = useState(false); // Track loading state
  // 🔹 ADD THIS - New state for CSCRF checklist data (like SUSAN Genie)
const [cscrfChecklistData, setCSCRFChecklistData] = useState(() => {
  // During initialization, we might not have userData yet
  // So we return empty object and let useEffect load it
  return {};
});
  // Persist responses to localStorage
  useEffect(() => {
    localStorage.setItem("responses", JSON.stringify(responses));
  }, [responses]);

useEffect(() => {
  if (!userData || !userData["cognito:username"]) return;
  
  const userId = userData["cognito:username"];
  const userKey = `cscrfChecklistData_${userId}`;
  const saved = localStorage.getItem(userKey);
  
  if (saved) {
    console.log("✅ [ScoreContext] Loaded CSCRF data from localStorage:", saved);
    const parsed = JSON.parse(saved);
    setCSCRFChecklistData(prev => ({
      ...prev,
      [userId]: parsed
    }));
  }
}, [userData]);


useEffect(() => {
  if (!userData || !userData["cognito:username"]) return;
  
  const userId = userData["cognito:username"];
  const userCSCRFData = cscrfChecklistData[userId];
  
  if (userCSCRFData) {
    const userKey = `cscrfChecklistData_${userId}`;
    localStorage.setItem(userKey, JSON.stringify(userCSCRFData));
    console.log("💾 [ScoreContext] Saved CSCRF data to localStorage:", userKey);
  }
}, [cscrfChecklistData, userData]);


  const clearResponsesForSection = useCallback((section) => {
    setResponses((prev) => {
      const updated = { ...prev };
      delete updated[section];
      return updated;
    });
  }, []);


  const updateScore = (section, questionId, value, metadata) => {
    setScoreData((prev) => {
      const updatedSection = prev[section] || {};
      updatedSection[questionId] = { value, ...metadata };
      return { ...prev, [section]: updatedSection };
    });
  };


  const getUserRegion = () => {
    return sessionStorage.getItem("userRegion") || "GB"; // Default to UK
  };




  const fetchResponsesForSection = useCallback(async (userId, section) => {
    try {
    
      //API is created
      const response = await fetch(`https://9qxkvgcmk3.execute-api.ap-southeast-2.amazonaws.com/prod/api/getresponses?userId=${userId}&section=${section}`,
        {
          method: "GET",
          headers: {
            "Region":  getUserRegion(), // Pass the region dynamically
          },
        }

      );
      if (!response.ok) {
       console.error(`❌ Failed fetch for section ${section}:`, response.status, response.statusText);
      return;
      }

      const data = await response.json();
    

      const formattedData = data.reduce((acc, res) => {
        acc[res.questionId] = res;
        return acc;
      }, {});

   setResponses((prev) => ({
        ...prev,
        [section]: formattedData,
      }));
    } catch (error) {
      console.error(`Error fetching responses for section ${section}:`, error);
    }
  }, []);

   const updateResponses = (section, questionId, response) => {
    setResponses((prev) => {
      const updatedSection = { ...prev[section], [questionId]: response };
      return { ...prev, [section]: updatedSection };
    });
  };
 
  const saveAllResponsesToBackend = useCallback(async (userId, section) => {
    const responsesForSection = responses[section];
    if (!responsesForSection) return;

    const responseData = {
      userId,
      section,
      responses: Object.values(responsesForSection),
    };
    
    try {
      
      const response = await fetch("https://h7qseagkd9.execute-api.ap-southeast-2.amazonaws.com/prod", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion(), // Include user region
        },
        body: JSON.stringify(responseData),
       
      });
      if (!response.ok) {
        throw new Error("Failed to save all responses");
      }
    
    } catch (error) {
      console.error("Error saving all responses:", error);
    }
  }, [responses]);

//   const fetchAllSections = useCallback(async (userId, sections) => {
//   if (!userId || !sections || sections.length === 0) {
//     setLoading(false); // Ensure loading is turned off!
//     return;
//   }
//   setLoading(true);
//   try {
//     const fetchPromises = sections.map(section =>
//       fetch(`https://yfzhsso2q0.execute-api.eu-west-1.amazonaws.com/api/getresponses?userId=${userId}&section=${section}`, {
//         method: "GET",
//         headers: { "Region": getUserRegion() },
//       })
//         .then(res => res.ok ? res.json() : Promise.reject(new Error(`Failed fetch for ${section}`)))
//         .then(data => ({ section, data }))
//         .catch(error => {
//           console.error(`Error fetching ${section}:`, error);
//           return { section, data: [] }; // Fallback to empty section
//         })
//     );

//     const results = await Promise.all(fetchPromises);
//     const mergedResponses = results.reduce((acc, { section, data }) => {
//       acc[section] = data.reduce((sectionAcc, res) => {
//         sectionAcc[res.questionId] = res;
//         return sectionAcc;
//       }, {});
//       return acc;
//     }, {});

//     setResponses(prev => ({ ...prev, ...mergedResponses }));
//   } catch (error) {
//     console.error("Error in fetchAllSections:", error);
//   } finally {
//     setLoading(false); // 🛑 Ensure loading is reset in both success and error cases
//   }
// }, []);



  // Automatically save responses to the backend when `responses` changes
 useEffect(() => {
    const userId = userData["cognito:username"]; // Replace with dynamic userId
    Object.keys(responses).forEach((section) => {
      saveAllResponsesToBackend(userId, section);
    });
  }, [responses, saveAllResponsesToBackend]);

  useEffect(() => {
    
    if (!responses || Object.keys(responses).length === 0) return;

    const newScoreData = {};
    Object.keys(responses).forEach((section) => {
      const sectionResponses = responses[section];
      const sectionScores = Object.keys(sectionResponses).reduce((acc, questionId) => {
        const { answer, questionText } = sectionResponses[questionId];
        acc[questionId] = {
          value: answer,
          questionText,
        };
        return acc;
      }, {});
      newScoreData[section] = sectionScores;
    });

    setScoreData(newScoreData);
  }, [responses]);



  const fetchActionPlan = async () => {
    let localPlan = [];
    let databasePlan = [];
    const userId = userData["cognito:username"];
    const uniqueQuestions = new Set();
    if (loading) return; // Prevent multiple fetches if already loading
    setLoading(true);
  
  
    // ✅ List of all sections
    const sections = [
      "AWSIAM",
      "AWSDetection",
      "AWSInfrastructureProtection",
      "AWSDataProtection",
      "AWSIRAutomation",
      "GenAI",
      "EntraAzureIAM",
      "EntraAzureDetection",
      "AzureInfraProtection",
      "AzureDataProtection",
      "EntraAzureAutomation",
      "GoogleCloudIAM",
      "GoogleCloudDetection",
      "GoogleInfraProtection",
      "GoogleDataProtection",
      "GoogleIRAutomation",
      "M365IAMMFA",
      "UserAdministration",
      "IntuneEnrollment",
      "GroupPolicies",
      "HybridConnect",
      "CloudMigration",
      "Sentinel",
      "BitLockerEncryption",
      "FirewallManagement",
      "WindowsUserPatching",
      "SSOEntApp",
      "BlockchainSecurity",
      "CISSecurity",
      "DevSecOps",
      "OperationalResilience",
      "DORASecurity",
      "CRASecurity",
      "NIS2Security",
      "CSCRFSecurity",
      "NCSBIrelandSecurity",
      "CSRBSecurity",
      "GovAssureSecurity",
      "CIRCIASecurity",
      "AIExecutiveOrdersSecurity",
      "PS213",
      "ICOEncryptionParticipation",
          "CSRBIncidentReporting",
          "PECRAlignment",
          "PostQuantumCryptography",
          "RegulatorEngagement",
          "MSPDataCentreFocus",
          "Organizational",
          "People",
          "Physical",
          "Technological",
          "LegalCompliance",
          "DataAndRiskMgmt",
          "PrivacyFramework",
          "PrivacyEngineering",
          "TelecomSecurityAct",
          "PCIDSSCompliance",
          "NCSCCAF",
          "PSNCompliance",
          "OTIoTSecurity",
          "NetworkSecurity",
          "PrivateCloudHypervisor",
          "Cisco",
          "Juniper",
          "Fortinet",
          "PaloAlto",
          "Checkpoint",
          "HIPAA",
          "RED",
          "EUAIActCompliance",
          "BS7858Security",
          "SOC2",
          "NISTSP80053",
          "NISTSP80063IAM",
          "NISTPrivacyFramework",
          "NISTSP800161",
          "NCSCSupplyChainGuidelines",
          "CERTINSupplyChainGuidelines",
          "PDPL",
          "CyberEssentials2014",
          "SOXCompliance",
          "MITRE",
          "OWASP",
          "COBIT",
          "OracleCloudIAM",
          "OracleCloudDetection",
          "OracleCloudInfrastructureProtection",
          "OracleCloudDataProtection",
          "OracleCloudIncidentResponseAndAutomation",

    ];
  
    try {
      
  
      // 1️⃣ Fetch from Local Storage
     
      if (responses && Object.keys(responses).length > 0) {
        Object.keys(responses).forEach((section) => {
          if (!sections.includes(section)) return;
  
          const sectionResponses = responses[section];
          const sectionQuestions = [
            ...(questionsData[section] || []),
            ...(EntraquestionData[section] || []),
            ...(GooglequestionData[section] || []),
            ...(M365[section] || []),
            ...(GenAI[section] || []),
            ...(BlockChain[section] || []),
            ...(iso_27001_compliance_checklist[section] || []),
            ...(CISSecurityAssessment[section] || []),
            ...(compliance_checklist[section] || []),
            ...(WirelessAndApplicationDatabaseSecurityQue[section] || []),
            ...(DevSecOps[section] || []),
            ...(OperationalResilience[section] || []),
            ...(DORA[section] || []),
            ...(CRA[section] || []),
            ...(NIS2[section] || []),
            ...(CSCRF[section] || []),
            ...(NCSB[section] || []),
            ...(CSRB[section] || []),
            ...(GovAssureSecurity[section] || []),
            ...(CIRCIA[section] || []),
            ...(AIExecutiveOrdersSecurity[section] || []),
            ...(PS21[section] || []),
            // ...(IncidentReporting[section] || []),
            ...(ThirdPartyInfrastructure[section] || []),
            ...(RegulatoryEngagement[section] || []),
            ...(EncryptionICOReadiness[section] || []),
            ...(QuantumResilientSecurity[section] || []),
            ...(PECRCompliance[section] || []),
            ...(CSRBIncidentReporting[section] || []),
            ...(TelecomSecurityAct[section] || []),
            ...(PCIDSSCompliance[section] || []),
            ...(NCSCCAF[section] || []),
            ...(PSNCompliance[section] || []),
             ...(OTIoTSecurity[section] || []),
               ...(NetworkSecurity[section] || []),
                ...(PrivateCloudHypervisor[section] || []),
                 ...(HIPAA[section] || []),
                 ...(RED[section] || []),
                 ...(EUAIActCompliance[section] || []),
                  ...(BS7858Security[section] || []),
                  ...(SOC2[section] || []),
                  ...(NISTSP80053[section] || []),
                   ...(NISTSP80063IAM[section] || []),
                    ...(NISTPrivacyFramework[section] || []),
                     ...(NISTSP800161[section] || []),
                      ...(NCSCSupplyChainGuidelines[section] || []),
                        ...(CERTINSupplyChainGuidelines[section] || []),
                        ...(PDPL[section] || []),
                         ...(CyberEssential[section] || []),
                          ...(SOXCompliance[section] || []),
                             ...(MITRE[section] || []),
                             ...(OWASP[section] || []),
                             ...(COBIT[section] || []),
                             ...(Oraclequestiondata[section] || []),
                  

          ];
          
          if (!sectionQuestions || sectionQuestions.length === 0) {
  console.warn(`⚠️ No questions found for section "${section}"`);
}
          Object.keys(sectionResponses).forEach((questionId) => {
            const questionData = sectionResponses[questionId];
            if (questionData.answer === "0" && !uniqueQuestions.has(questionId)) {
              const questionMatch = sectionQuestions.find(
                (q) => q.questionId === parseInt(questionId)
              );
              if (questionMatch) {
                localPlan.push({
                  question: questionMatch.question || "No question available",
                  moreInformation: questionMatch.moreInformation || null,
                });
                uniqueQuestions.add(questionId);
              }
            }
          });
        });
      }
  
       // 2️⃣ Fetch from API in Parallel
       const fetchPromises = sections.map((section) =>
        fetch(`https://9qxkvgcmk3.execute-api.ap-southeast-2.amazonaws.com/prod/api/getresponses?userId=${userId}&section=${section}`, {
            method: "GET",
            headers: {
                "Region": getUserRegion(),
            },
        }).then((response) => {
            if (!response.ok) {
                console.error(`Failed to fetch responses for section ${section}`);
                return [];
            }
            return response.json().then((data) => ({ section, data }));
        })
    );

    const results = await Promise.all(fetchPromises);

    results.forEach(({ section, data }) => {
        const sectionQuestions = [
            ...(questionsData[section] || []),
            ...(EntraquestionData[section] || []),
            ...(GooglequestionData[section] || []),
            ...(M365[section] || []),
            ...(GenAI[section] || []),
            ...(BlockChain[section] || []),
            ...(iso_27001_compliance_checklist[section] || []),
            ...(CISSecurityAssessment[section] || []),
            ...(compliance_checklist[section] || []),
            ...(WirelessAndApplicationDatabaseSecurityQue[section] || []),
            ...(DevSecOps[section] || []),
            ...(OperationalResilience[section] || []),
             ...(DORA[section] || []),
            ...(CRA[section] || []),
            ...(NIS2[section] || []),
            ...(CSCRF[section] || []),
            ...(NCSB[section] || []),
            ...(CSRB[section] || []),
            ...(GovAssureSecurity[section] || []),
            ...(CIRCIA[section] || []),
            ...(AIExecutiveOrdersSecurity[section] || []),
            ...(PS21[section] || []),
            // ...(IncidentReporting[section] || []),
            ...(ThirdPartyInfrastructure[section] || []),
            ...(RegulatoryEngagement[section] || []),
            ...(EncryptionICOReadiness[section] || []),
            ...(QuantumResilientSecurity[section] || []),
            ...(PECRCompliance[section] || []),
            ...(TelecomSecurityAct[section] || []),
            ...(PCIDSSCompliance[section] || []),
            ...(NCSCCAF[section] || []),
            ...(PSNCompliance[section] || []),
             ...(OTIoTSecurity[section] || []),
              ...(NetworkSecurity[section] || []),
               ...(PrivateCloudHypervisor[section] || []),
               ...(HIPAA[section] || []),
                ...(RED[section] || []),
                 ...(EUAIActCompliance[section] || []),
                  ...(BS7858Security[section] || []),
                  ...(SOC2[section] || []),
                   ...(NISTSP80053[section] || []),
                    ...(NISTSP80063IAM[section] || []),
                 ...(NISTPrivacyFramework[section] || []),
                    ...(NISTSP800161[section] || []),
                    ...(NCSCSupplyChainGuidelines[section] || []),
                    ...(CERTINSupplyChainGuidelines[section] || []),
                     ...(PDPL[section] || []),
                     ...(CyberEssential[section] || []),
                        ...(SOXCompliance[section] || []),
                          ...(MITRE[section] || []),
                            ...(OWASP[section] || []),
                             ...(COBIT[section] || []),
                              ...(Oraclequestiondata[section] || []),



            
        ];

        data.forEach((res) => {
            if (res.answer === "0" && !uniqueQuestions.has(res.questionId)) {
                const questionMatch = sectionQuestions.find(
                    (q) => q.questionId === parseInt(res.questionId)
                );
                databasePlan.push({
                    question: res.questionText || "No question available",
                    moreInformation: questionMatch
                        ? questionMatch.moreInformation
                        : null,
                });
                uniqueQuestions.add(res.questionId);
            }
        });
    });

} catch (error) {
    console.error("Error fetching action plan from database:", error);
} finally {
    setActionPlan([...localPlan, ...databasePlan]);
    setLoading(false); // End loading
}
};
  
  const fetchInvitedUserAssessment = useCallback(async (userEmail) => {
  try {
    const region = sessionStorage.getItem("userRegion") || "IN";
    const response = await fetch(
       `https://y56vrkh658.execute-api.ap-southeast-2.amazonaws.com/prod/api/user-assessment?email=${userEmail}`,
     
      {
        method: "GET",
       
        headers: { "Region": region },
      }
    );
    
    if (!response.ok) {
      throw new Error(`Failed to fetch assessment for ${userEmail}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching assessment for ${userEmail}:`, error);
    return null;
  }
}, []);

const fetchInvitedUserResponses = useCallback(async (userId) => {
  try {
    const region = sessionStorage.getItem("userRegion") || "IN";

    
    const allSections = [
      "AWSIAM", "AWSDetection", "AWSInfrastructureProtection", "AWSDataProtection", "AWSIRAutomation",
      "GenAI", "EntraAzureIAM", "EntraAzureDetection", "AzureInfraProtection", "AzureDataProtection",
      "EntraAzureAutomation", "GoogleCloudIAM", "GoogleCloudDetection", "GoogleInfraProtection",
      "GoogleDataProtection", "GoogleIRAutomation", "M365IAMMFA", "UserAdministration", "IntuneEnrollment",
      "GroupPolicies", "HybridConnect", "CloudMigration", "Sentinel", "BitLockerEncryption", 
      "FirewallManagement", "WindowsUserPatching", "SSOEntApp", "BlockchainSecurity", "Organizational",
      "People", "Physical", "Technological", "DataAndRiskMgmt", "LegalCompliance", "PrivacyEngineering",
      "PrivacyFramework", "CISSecurity", "DevSecOps", "OperationalResilience", "DORASecurity",
      "CRASecurity", "NIS2Security", "CSCRFSecurity", "NCSBIrelandSecurity", "CSRBSecurity",
      "GovAssureSecurity", "CIRCIASecurity", "AIExecutiveOrdersSecurity", "PS213", 
      "ICOEncryptionParticipation", "CSRBIncidentReporting", "PECRAlignment", "PostQuantumCryptography",
      "RegulatorEngagement", "MSPDataCentreFocus", "TelecomSecurityAct", "PCIDSSCompliance",
      "NCSCCAF", "PSNCompliance", "OTIoTSecurity", "NetworkSecurity", "PrivateCloudHypervisor",
      "Cisco", "Juniper", "Fortinet", "PaloAlto", "Checkpoint", "HIPAA", "RED", "EUAIActCompliance",
      "BS7858Security", "SOC2", "NISTSP80053", "NISTSP80063IAM", "NISTPrivacyFramework",
      "NISTSP800161", "NCSCSupplyChainGuidelines", "CERTINSupplyChainGuidelines","PDPL","CyberEssentials2014","SOXCompliance","MITRE", "OWASP",
          "COBIT",  "OracleCloudIAM",
          "OracleCloudDetection",
          "OracleCloudInfrastructureProtection",
          "OracleCloudDataProtection",
          "OracleCloudIncidentResponseAndAutomation",
    ];

    const fetchPromises = allSections.map(section =>
     fetch(`https://9qxkvgcmk3.execute-api.ap-southeast-2.amazonaws.com/prod/api/getresponses?userId=${userId}&section=${section}`, {
    
        method: "GET",
        headers: { "Region": region },
      })
      .then(res => res.ok ? res.json() : [])
      .then(data => ({ section, data }))
      .catch(() => ({ section, data: [] }))
    );

    const results = await Promise.all(fetchPromises);
    const userResponses = {};
    
    results.forEach(({ section, data }) => {
      if (data.length > 0) {
        userResponses[section] = data.reduce((acc, response) => {
          acc[response.questionId] = response;
          return acc;
        }, {});
      }
    });

    return userResponses;
  } catch (error) {
    console.error(`Error fetching responses for user ${userId}:`, error);
    return {};
  }
}, []);

const importFromInvitedUser = useCallback((invitedUserData, selectedModules = null) => {
  try {
    if (!invitedUserData.responses) {
      return { success: false, message: "No responses found in user data" };
    }

    const importedResponses = {};
    let importedCount = 0;

    const availableModules = Object.keys(invitedUserData.responses);
    const modulesToImport = selectedModules ? 
      availableModules.filter(module => selectedModules.includes(module)) : 
      availableModules;

    modulesToImport.forEach(section => {
      const sectionData = invitedUserData.responses[section];
      
      if (typeof sectionData === 'object' && sectionData !== null) {
        importedResponses[section] = {};
        
        Object.keys(sectionData).forEach(questionKey => {
          const questionData = sectionData[questionKey];
          
          if (questionData && (questionData.answer !== undefined)) {
            let normalizedAnswer = questionData.answer;
            
            if (typeof normalizedAnswer === 'string') {
              normalizedAnswer = normalizedAnswer === '1' ? 1 : 
                                normalizedAnswer === '0' ? 0 : normalizedAnswer;
            }
            
            importedResponses[section][questionData.questionId || questionKey] = {
              questionId: questionData.questionId || questionKey,
              answer: normalizedAnswer,
              questionText: questionData.questionText || 'Imported question',
              timestamp: questionData.timestamp || new Date().toISOString()
            };
            importedCount++;
          }
        });
      }
    });

    // Update the responses state with imported data
    setResponses(prev => ({
      ...prev,
      ...importedResponses
    }));

    console.log(`✅ Successfully imported ${importedCount} responses from ${modulesToImport.length} modules`);
    return { 
      success: true, 
      message: `Imported ${importedCount} responses from ${modulesToImport.length} modules.`,
      importedModules: modulesToImport,
      importedCount
    };
    
  } catch (error) {
    console.error("❌ Error importing user data:", error);
    return { success: false, message: "Failed to import data: " + error.message };
  }
}, []);
// 🔹 ADD THESE THREE FUNCTIONS - Before the return statement

// Update CSCRF checklist data
const updateCSCRFChecklist = useCallback((userId, checklistData) => {
  console.log("📝 [ScoreContext] Updating CSCRF checklist:", {
    userId,
    itemCount: Object.keys(checklistData).length
  });
  
  setCSCRFChecklistData(prev => ({
    ...prev,
    [userId]: {
      ...prev[userId],
      ...checklistData,
      lastUpdated: new Date().toISOString()
    }
  }));
}, []);

// Save CSCRF checklist to backend
const saveCSCRFChecklistToBackend = useCallback(async (userId) => {
  const userCSCRFData = cscrfChecklistData[userId];
  
  if (!userCSCRFData || Object.keys(userCSCRFData).length === 0) {
    console.log("⚠️ [ScoreContext] No CSCRF data to save");
    return;
  }

  console.log("💾 [ScoreContext] Saving CSCRF checklist to backend:", {
    userId,
    itemCount: Object.keys(userCSCRFData).length - 1 // -1 for lastUpdated field
  });

  try {
    const response = await fetch(
      "https://h7qseagkd9.execute-api.ap-southeast-2.amazonaws.com/prod",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion(),
        },
        body: JSON.stringify({
          userId,
          section: "CSCRFChecklist",
          cscrfData: userCSCRFData,
          timestamp: new Date().toISOString()
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to save CSCRF checklist");
    }

    console.log("✅ [ScoreContext] CSCRF checklist saved successfully");
  } catch (error) {
    console.error("❌ [ScoreContext] Error saving CSCRF checklist:", error);
  }
}, [cscrfChecklistData]);

// Fetch CSCRF checklist from backend
const fetchCSCRFChecklist = useCallback(async (userId) => {
  console.log("🔽 [ScoreContext] Fetching CSCRF checklist for user:", userId);

  try {
    const response = await fetch(
      `https://9qxkvgcmk3.execute-api.ap-southeast-2.amazonaws.com/prod/api/getresponses?userId=${userId}&section=CSCRFChecklist`,
      {
        method: "GET",
        headers: {
          "Region": getUserRegion(),
        },
      }
    );

    if (!response.ok) {
      console.warn("⚠️ [ScoreContext] No CSCRF data found for user");
      return;
    }

    const data = await response.json();
    console.log("✅ [ScoreContext] Fetched CSCRF checklist:", data);

    // Transform array to object format
    const cscrfDataObj = data.reduce((acc, item) => {
      acc[item.checklistItemId || item.id] = item;
      return acc;
    }, {});

    setCSCRFChecklistData(prev => ({
      ...prev,
      [userId]: cscrfDataObj
    }));
  } catch (error) {
    console.error("❌ [ScoreContext] Error fetching CSCRF checklist:", error);
  }
}, []);


  return (
    <ScoreContext.Provider
      value={{
        overviewData, 
        setOverviewData,
        actionPlan,
        scoreData,
        updateScore,
        responses,
        fetchResponsesForSection,
        updateResponses,
        saveAllResponsesToBackend,
        clearResponsesForSection,
        fetchActionPlan,
        loading,
        fetchInvitedUserAssessment,
      fetchInvitedUserResponses,
      importFromInvitedUser,

       cscrfChecklistData,
      updateCSCRFChecklist,
      saveCSCRFChecklistToBackend,
      fetchCSCRFChecklist,
    
      }}
    >
      {children}
    </ScoreContext.Provider>
  );
};
